
import React, { useEffect, useState } from "react";
import { Navbar, Container, Nav, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { getProductsData } from '../../modules/storeHome/store/selectors';
import { filter } from "lodash";

const getProductLink = (product) => {
	if (
		product.Name == "BTE/RICs" ||
		product.Name == "ITEs" ||
		product.Name == "Stock Orders"
	) {
		return `/store/${product.Code}`;
	}

	if (product.Name == "Custom Hearing Protection" || product.Code == "Earpiece") {
		return `/store/${product.Code}/${product.InverseParentCodeNavigation[0].Code}`;
	}

	return `/store/${product.Code}/${product.Type}`;
};

const getNavigationProducts = (productsData) => {
	const validProducts = filter(
		productsData,
		(product) => product != null && product.Type
	);

	return validProducts.map((product) => ({
		...product,
		NavigationLink: getProductLink(product),
	}));
};

const NavbarLinks = ({
	productsData
}) => {
	const [tempProductsData, setTempProductsData] = useState([]);
	let displayIndex = 0;
	useEffect(() => {
		if (productsData) {
			setTempProductsData(getNavigationProducts(productsData));
		}
	}, [productsData])

	return (
		<Navbar>
			<Container>
				<Nav className="me-auto">
					{(tempProductsData && tempProductsData.length > 0) && (
						tempProductsData.map((product, index) => {
							return (
								<Link key={product.Code} className={`nav-link ${index == 0 ? "nav-link-left" : ""}`} to={product.NavigationLink}>
									{product.Name === "Stock / Consumables" ? "Stock/Consumables/SpareParts" : product.Name} {(product.Name == "BTE/RICs" || product.Name == "ITEs") ? "Hearing Aids" : ""}
								</Link>
							)
						})
					)}
					{/* <Link className="nav-link" to="/store/PH001002">
						ITE Hearing Aids
					</Link>
					<Link className="nav-link" to="/item-builder/PH007/earmolds">
						Ear Pieces
					</Link> */}
					{/* <Link className="nav-link" to="/">
						Accessories
					</Link> */}
				</Nav>
				<Nav className="justify-content-end">
					<Link className="nav-link" to="/admin/organisation">
						Organisations
					</Link>
					<Link className="nav-link" to="/admin/adminusers">
						Admin Users
					</Link>
				</Nav>
			</Container>
		</Navbar>
	);
}


const mapStateToProps = (state) => ({
	productsData: getProductsData(state),
});

export default connect(mapStateToProps)(NavbarLinks);
